import { render, staticRenderFns } from "./TaxCalculatorLoader.vue?vue&type=template&id=244920e9&scoped=true"
import script from "./TaxCalculatorLoader.vue?vue&type=script&lang=ts"
export * from "./TaxCalculatorLoader.vue?vue&type=script&lang=ts"
import style0 from "./TaxCalculatorLoader.vue?vue&type=style&index=0&id=244920e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244920e9",
  null
  
)

export default component.exports